import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginAppsComponent } from './login-apps.component';
import { TranslateModule } from '@xref/ngx';

@NgModule({
    declarations: [LoginAppsComponent],
    imports: [
        CommonModule,
        TranslateModule
    ],
    exports: [
        LoginAppsComponent
    ]
})
export class LoginAppsModule { }
